// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLast3MonthsDataButton_root__qT5Ba","text":"PlasmicLast3MonthsDataButton_text__0XdeW"};